// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1c_Zu","noInteraction":"EventWrapper_noInteraction__2Oi6n","pointerPassthrough":"EventWrapper_pointerPassthrough__2aRRz"};